































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue"
import PdfRenderArea from "../../components/PdfRenderArea.vue"
import { BaseSheet } from "../../modules/teacher/ExplanationPdfUpload"

export interface Data {
  tabNo: number
  base_sheet_id: string
  baseSheet: BaseSheet
  base64Pdf: string
  errors: string[]
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "pdf-render-area": PdfRenderArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    const pdfRenderAreaRef = ref<InstanceType<typeof PdfRenderArea>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 5,
      base_sheet_id: "",
      baseSheet: null,
      base64Pdf: "",
      errors: new Array<string>()
    });

    /******************************
     * 解答PDF画面へ移動
     ******************************/

    const toQuestionPdfUpload = () => {
      context.root.$router.push(`/teacher_site/question_pdf_upload/${state.base_sheet_id}`).catch(err => {});
    };

    /******************************
     * ファイルアップロード
     ******************************/

    const upload = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/explanation_pdf_upload/upload/${state.base_sheet_id}`, fd).then(response => {
        alert("アップロードが完了しました。");
        location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      await http.get(`/api/explanation_pdf_upload?base_sheet_id=${state.base_sheet_id}`).then(response => {
        
        state.baseSheet = new BaseSheet(response.data.base_sheet);
        
        context.root.$nextTick(() => {
          if(state.baseSheet.explanation_image_completed){
            state.base64Pdf = response.data.base64_pdf;
          }
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      upload,
      toQuestionPdfUpload,
    };
  }
});
